<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div class="flex flex-row flex-nowrap md:gap-3 items-center justify-between">
  <div class="flex flex-wrap w-1/4 justify-start">
    <img
      [routerLink]="['/packs']"
      alt="img"
      class="left-arrow clickable"
      src="../../../../assets/icons/left-arrow.svg"
    />
    <h1 class="headeradminui-text pl-2">
      {{ isEdit ? "Edit" : "Add" }} anyo packs
    </h1>
  </div>
</div>
<nz-spin [nzSpinning]="pageLoading">
  <nz-card>
    <nz-divider nzText="Basic Details"></nz-divider>
    <div nz-row nzGutter="16">
      <!-- Pack Name -->
      <div nz-col nzSpan="8">
        <nz-form-item>
          <nz-form-label nzFor="packName" nzRequired nzSpan="24">
            Pack Name
          </nz-form-label>
          <nz-form-control nzSpan="24">
            <input
              [(ngModel)]="packName"
              type="text"
              id="packName"
              nz-input
              placeholder="Enter Pack Name"
            />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="packName" nzRequired nzSpan="24">
            Sub Title
          </nz-form-label>
          <nz-form-control nzSpan="24">
            <input
              [(ngModel)]="subTitle"
              type="text"
              id="subTitle"
              nz-input
              placeholder="Enter Sub Title"
            />
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Internal Pack Name -->
      <div nz-col nzSpan="8">
        <nz-form-item>
          <nz-form-label nzFor="internalPackName" nzRequired nzSpan="24">
            Internal Pack Name
          </nz-form-label>
          <nz-form-control nzSpan="24">
            <input
              [(ngModel)]="internalPackName"
              type="text"
              id="internalPackName"
              nz-input
              placeholder="Enter Internal Pack Name"
            />
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Description -->
      <div nz-col nzSpan="8">
        <nz-form-item>
          <nz-form-label nzFor="packDescription" nzRequired nzSpan="24">
            Description
          </nz-form-label>
          <nz-form-control nzSpan="24">
            <textarea
              [(ngModel)]="packDescription"
              id="packDescription"
              nz-input
              placeholder="Enter Description"
              rows="5"
              style="resize: none"
            ></textarea>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <div nz-row nzGutter="16">
      <!-- Slug Name -->
      <div nz-col nzSpan="8">
        <nz-form-item>
          <nz-form-label nzFor="slugName" nzRequired nzSpan="24">
            Slug Name
          </nz-form-label>
          <nz-form-control nzSpan="24">
            <input
              [(ngModel)]="slugName"
              type="text"
              id="slugName"
              nz-input
              placeholder="Enter Slug Name"
            />
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Visible & Active Switches -->
      <div nz-col nzSpan="8">
        <nz-form-item>
          <nz-form-label nzSpan="24">Visibility</nz-form-label>
          <nz-form-control nzSpan="24">
            <div class="flex flex-row space-x-6">
              <div class="flex flex-row items-center">
                <nz-form-label>Visible</nz-form-label>
                <nz-switch [(ngModel)]="isVisible"></nz-switch>
              </div>

              <div class="flex flex-row items-center">
                <nz-form-label>Active</nz-form-label>
                <nz-switch [(ngModel)]="isActive"></nz-switch>
              </div>
            </div>
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Empty column -->
      <div nz-col nzSpan="8">
        <nz-form-item>
          <nz-form-label nzSpan="24">Package Tag</nz-form-label>
          <nz-form-control nzSpan="24">
            <nz-select
              [(ngModel)]="packageTag"
              [nzOptions]="packTagOption"
              nzPlaceHolder="Select a tag"
              [nzDisabled]="false"
            ></nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <div nz-row nzGutter="16">
      <div nz-col nzSpan="8">
        <nz-form-item>
          <nz-form-label nzFor="primarySesssionDuration" nzSpan="24">
            Primary Sesssion Duration
          </nz-form-label>
          <nz-form-control nzSpan="24">
            <input
              [(ngModel)]="primarySesssionDuration"
              type="number"
              id="primarySesssionDuration"
              nz-input
              placeholder="Enter primary Sesssion Duration"
            />
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSpan="8">
        <nz-form-item>
          <nz-form-label nzFor="auxiliarySessionDuration" nzSpan="24">
            Auxiliary Session Duration
          </nz-form-label>
          <nz-form-control nzSpan="24">
            <input
              [(ngModel)]="auxiliarySessionDuration"
              type="number"
              id="auxiliarySessionDuration"
              nz-input
              placeholder="Enter Auxiliary Session Duration"
            />
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <div nz-row nzGutter="16">
      <div nz-col nzSpan="20">
        <nz-form-item>
          <nz-form-label nzFor="assessmentPrompt" nzSpan="24">
            Assessment Prompt
          </nz-form-label>
          <nz-form-control nzSpan="24">
            <textarea
              [(ngModel)]="assessmentPrompt"
              id="assessmentPrompt"
              nz-input
              placeholder="Enter Assessment Prompt"
              rows="5"
            ></textarea>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <nz-divider nzText="Discipline details"> </nz-divider>
    <div nz-row nzGutter="16">
      <div nz-col nzSpan="12">
        <nz-form-item>
          <nz-form-label nzFor="firstMultiSelect" nzSpan="24">
            Primary concern
          </nz-form-label>
          <nz-form-control nzSpan="24">
            <nz-select
              [(ngModel)]="selectedPrimaryConcern"
              (ngModelChange)="filterAuxiliaryOptions()"
              [nzAllowClear]="true"
              nzPlaceHolder="Select a primary concern"
              id="firstMultiSelect"
            >
              <nz-option
                *ngFor="let option of concernOption"
                [nzValue]="option.value"
                [nzLabel]="option.label"
              ></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSpan="12">
        <nz-form-item>
          <nz-form-label nzFor="secondMultiSelect" nzSpan="24"
            >Auxiliary concern</nz-form-label
          >
          <nz-form-control nzSpan="24">
            <nz-select
              [(ngModel)]="selectedAuxiliaryConcern"
              [nzMode]="'multiple'"
              [nzDisabled]="true"
              nzPlaceHolder="Auxiliary Concern"
              id="secondMultiSelect"
            >
              <nz-option
                *ngFor="let option of auxiliaryOptions"
                [nzValue]="option.value"
                [nzLabel]="option.label"
              ></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <div nz-col nzSpan="12">
      <nz-form-item>
        <nz-form-label nzFor="firstMultiSelect" nzSpan="24">
          Primary Therapist Expertise
        </nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select
            [(ngModel)]="selectedPrimaryExpertise"
            [nzAllowClear]="true"
            nzPlaceHolder="Select a primary Therapist Expertise"
            id="firstMultiSelect"
          >
            <nz-option
              *ngFor="let option of packsExpertise"
              [nzValue]="option.value"
              [nzLabel]="option.label"
            ></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div>
      <nz-divider nzText="Variants"> </nz-divider>
      <div class="space-y-5">
        <div
          *ngFor="let variation of variations; let i = index"
          class="border p-4 rounded-lg shadow-sm"
        >
          <div nz-row nzGutter="16">
            <!-- Row 1 -->
            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label nzFor="variantName{{ i }}" nzSpan="24"
                  >Variant Name</nz-form-label
                >
                <nz-form-control nzSpan="24">
                  <input
                    [(ngModel)]="variation.variantName"
                    [id]="'variantName' + i"
                    nz-input
                    placeholder="Enter name"
                  />
                </nz-form-control>
              </nz-form-item>
            </div>

            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label nzSpan="24">Variant Tag</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select
                    [(ngModel)]="variation.variantTags[0]"
                    [nzOptions]="variantTagOptions"
                    nzPlaceHolder="Select a tag"
                    [nzDisabled]="false"
                  ></nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>

            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label nzFor="amount{{ i }}" nzSpan="24"
                  >Amount</nz-form-label
                >
                <nz-form-control nzSpan="24">
                  <input
                    [(ngModel)]="variation.charges.amount"
                    type="number"
                    [id]="'amount' + i"
                    nz-input
                  />
                </nz-form-control>
              </nz-form-item>
            </div>

            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label nzFor="markupAmount{{ i }}" nzSpan="24"
                  >Markup Amount</nz-form-label
                >
                <nz-form-control nzSpan="24">
                  <input
                    [(ngModel)]="variation.charges.markupAmount"
                    type="number"
                    [id]="'markupAmount' + i"
                    nz-input
                  />
                </nz-form-control>
              </nz-form-item>
            </div>

            <!-- Row 2 -->
            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label nzFor="savingText{{ i }}" nzSpan="24"
                  >Saving Text</nz-form-label
                >
                <nz-form-control nzSpan="24">
                  <input
                    [(ngModel)]="variation.charges.savingText"
                    type="text"
                    [id]="'savingText' + i"
                    nz-input
                  />
                </nz-form-control>
              </nz-form-item>
            </div>

            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label nzFor="perSessionAmount{{ i }}" nzSpan="24"
                  >Per Session Amount</nz-form-label
                >
                <nz-form-control nzSpan="24">
                  <input
                    [(ngModel)]="variation.charges.perSessionAmount"
                    type="number"
                    [id]="'perSessionAmount' + i"
                    nz-input
                  />
                </nz-form-control>
              </nz-form-item>
            </div>

            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label nzFor="primarySessions{{ i }}" nzSpan="24"
                  >Primary Sessions</nz-form-label
                >
                <nz-form-control nzSpan="24">
                  <input
                    [(ngModel)]="variation.noOfSessions.primary"
                    type="number"
                    [id]="'primarySessions' + i"
                    nz-input
                  />
                </nz-form-control>
              </nz-form-item>
            </div>

            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label>Auxiliary Sessions</nz-form-label>
                <nz-form-control>
                  <input
                    nz-input
                    type="number"
                    [(ngModel)]="variation.noOfSessions.auxiliary[0]"
                    placeholder="Enter number"
                  />
                </nz-form-control>
              </nz-form-item>
            </div>

            <!-- Row 3 -->
            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label nzFor="packageDuration{{ i }}" nzSpan="24"
                  >Package Duration (days)</nz-form-label
                >
                <nz-form-control nzSpan="24">
                  <input
                    [(ngModel)]="variation.packageDuration"
                    type="number"
                    [id]="'packageDuration' + i"
                    nz-input
                  />
                </nz-form-control>
              </nz-form-item>
            </div>

            <div nz-col nzSpan="6">
              <nz-form-item>
                <nz-form-label nzSpan="24">Payment Type</nz-form-label>
                <nz-form-control nzSpan="24">
                  <nz-select
                    [(ngModel)]="variation.paymentType"
                    [nzOptions]="paymentTypeOptions"
                    nzPlaceHolder="Select payment type"
                    [disabled]="true"
                  ></nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
        </div>

        <!-- Add Variant Button -->
        <button
          [disabled]="!canAddNewVariant()"
          (click)="addNewVariant()"
          nz-button
          nzType="primary"
          class="mt-4"
        >
          Add Variant
        </button>
      </div>
    </div>
    <nz-divider nzText="Ui details section"> </nz-divider>
    <div nz-row nzGutter="16">
      <div nz-col [nzSpan]="12">
        <label
          >Package Card Picture ( Single , ratio of image dimension should be
          1:1 )</label
        >
        <input
          type="file"
          accept="image/*"
          (change)="onPackageCardPictureChange($event)"
        />
        <div *ngIf="imageUrl" class="image-preview">
          <img [src]="imageUrl" alt="Package Card Picture" />
        </div>
      </div>
    </div>
    <div nz-row class="mt-5">
      <div nz-col>
        <label [(ngModel)]="isTesting" nz-checkbox> Test Pack </label>
      </div>
    </div>
    <nz-divider nzText="Therapist Details"> </nz-divider>
    <div
      class="flex items-center justify-evenly"
      style="background: #ececec; padding: 30px"
    >
      <nz-card
        style="width: 300px"
        [nzBordered]="false"
        nzTitle="Primary Therapist Details"
      >
        <div *ngIf="pack.primaryConcern && pack.primaryConcern.length">
          <div *ngFor="let concern of getConcernNames(pack.primaryConcern)">
            Primary Concern : <nz-tag [nzColor]="'blue'">{{ concern }}</nz-tag>
          </div>
        </div>
        <br />
        Expertise On :
        <ng-container>
          <nz-tag class="mt-2 mb-2" [nzColor]="'green'">{{
            pack.primaryTherapistExpertiseName
          }}</nz-tag>
        </ng-container>
        <br />
        Experts :
        <div *ngFor="let experts of pack.therapistDetails">
          {{ experts.name }}
        </div>
        <!-- <p>Primary Concern : {{getConcernNames(pack.primaryConcern)}}</p>

        <p>Expertise On : {{pack.primaryTherapistExpertiseName}}</p>
        <p>Experts :</p>
        <div *ngFor="let experts of pack.therapistDetails">
          {{experts.name}}
        </div> -->
      </nz-card>
      <nz-card
        style="width: 300px"
        [nzBordered]="false"
        nzTitle="Auxilary Therapist Details"
      >
        <div
          *ngFor="let th of pack.auxilaryTherapistDetails; index as i"
          class="flex flex-col gap-2 mt-2 mb-2"
        >
          <div class="flex flex-col gap-2">
            <h1>{{ i + 1 + ")Expert Name : " + th.therapistName }}</h1>
            Expertise On :
            <div class="flex flex-wrap">
              <nz-tag
                class="mt-1 mb-1"
                *ngFor="let tag of th.expertiseName"
                [nzColor]="'purple'"
                >{{ tag }}</nz-tag
              >
            </div>
          </div>
        </div>
        <!-- <p>Experts :</p>
        <div *ngFor="let experts of pack.auxilaryTherapistDetails">
         <p> Therapist Name : {{experts.therapistName}}</p>
          <p>Expertise On : {{experts.expertiseName}}</p>
        </div> -->
      </nz-card>
    </div>
    <div nz-row class="pt-4" nzJustify="end">
      <div nz-col>
        <button (click)="savePack()" nz-button nzType="primary">
          {{ isEdit ? "Update" : "Save" }} Pack
        </button>
      </div>
    </div>
  </nz-card>
</nz-spin>
